import { Button, Modal } from "antd";
import { Image } from "antd";
import "./BeginModal.scss";
import beginVideo from "@assets/img/sample.png";

interface IBeginModal {
  isOpen: boolean;
  closeModal: () => void;
  setIsTourOpen: (value: boolean) => void;
  setIsOpenCreateForm: (value: boolean) => void;
}

const BeginModal: React.FC<IBeginModal> = ({
  isOpen,
  setIsTourOpen,
  closeModal,
  setIsOpenCreateForm,
}) => {
  const handleGetStarted = () => {
    closeModal();
    setIsOpenCreateForm(true);
    setTimeout(() => {
        setIsTourOpen(true);
    }, 500)
  };

  const handleExplore = () => {
    closeModal();
    setIsOpenCreateForm(true);
  };

  return (
    <Modal
      className="BeginModal"
      open={isOpen}
      onCancel={closeModal}
      width={"60vw"}
      footer={false}
    >
      <div className="container begin-container">
        <div className="begin-title">Welcome to HEPPAI</div>
        <Image className="begin-video" src={beginVideo} />
        <div className="begin-description">
          Let's find out how we can help you, in less then a minute
        </div>
        <Button className="get-started-btn" onClick={handleGetStarted}>
          Get Started
        </Button>
        <Button
          className="explore-btn"
          onClick={handleExplore}
          color="default"
          variant="link"
        >
          Explore by Yourself
        </Button>
      </div>
    </Modal>
  );
};

export default BeginModal;
